export const aboutInfo = {
  brandStory: {
    title: 'JMTT品牌故事',
    subtitle: '源于初心，成于坚持',
    paragraphs: [
      'JMTT成立于2020年，由一群怀揣梦想的技术专家和行业资深人士共同创立。我们的初心很简单 —— 打造一个真正以用户为中心、值得信赖的优质平台，让每个人都能轻松享受到数字化时代带来的便利与价值。',
      '创业初期，团队只有不到20人，挤在一间小小的办公室里。但大家怀揣着对技术的热爱和对用户需求的深刻理解，夜以继日地打磨产品。经过无数次迭代优化，JMTT逐渐从一个简单的工具演变为涵盖数据管理、交易处理、智能营销、协作办公等多元功能的一站式平台。',
      '如今，JMTT已服务超过500万活跃用户，业务覆盖全球200多个国家和地区。但我们始终没有忘记初心 —— 持续创新，为用户创造真正的价值。每一个功能的开发、每一次版本的迭代，都源于我们对用户需求的深度洞察和对产品品质的不懈追求。',
      '未来，JMTT将继续加大技术研发投入，探索人工智能、大数据、区块链等前沿技术在平台中的应用，为全球用户提供更加智能、高效、安全的数字化服务。我们相信，最好的产品永远在下一个版本。'
    ]
  },
  milestones: [
    { year: '2020', month: '3月', title: 'JMTT正式成立', description: '创始团队组建完成，获得首轮天使投资，JMTT项目正式启动研发。' },
    { year: '2020', month: '9月', title: 'Beta版本发布', description: '经过半年紧张开发，JMTT Beta版本上线，首批邀请100位种子用户参与内测。' },
    { year: '2021', month: '3月', title: '正式版v1.0上线', description: 'JMTT正式版面向公众发布，用户数在三个月内突破10万，获得市场热烈反响。' },
    { year: '2021', month: '9月', title: '完成A轮融资', description: '获得知名投资机构青睐，顺利完成A轮融资，团队规模扩展至100人。' },
    { year: '2022', month: '6月', title: '用户突破百万', description: 'JMTT注册用户突破100万大关，平台日均交易额首次超过1亿元。' },
    { year: '2023', month: '3月', title: '国际化战略启动', description: '推出多语言版本，正式进军海外市场，首批覆盖东南亚及欧美主要国家。' },
    { year: '2024', month: '6月', title: '荣获行业大奖', description: '凭借卓越的产品体验和用户口碑，荣获"年度最佳企业服务平台"等多项行业大奖。' },
    { year: '2025', month: '9月', title: 'AI战略全面升级', description: '发布AI智能助手，将人工智能技术深度融入平台各项服务，开启智能化新篇章。' },
    { year: '2026', month: '3月', title: '用户突破500万', description: '全球活跃用户突破500万，覆盖200+国家和地区，成为行业领军平台。' }
  ],
  honors: [
    { id: 1, title: '年度最佳企业服务平台', year: '2026', issuer: '中国企业服务协会' },
    { id: 2, title: '技术创新先锋奖', year: '2025', issuer: '中国互联网协会' },
    { id: 3, title: '用户最喜爱平台TOP10', year: '2025', issuer: '数字中国峰会' },
    { id: 4, title: '信息安全等级保护三级认证', year: '2024', issuer: '公安部信息安全等级保护评估中心' },
    { id: 5, title: '最佳SaaS产品奖', year: '2024', issuer: '中国软件行业协会' },
    { id: 6, title: '年度成长最快企业', year: '2023', issuer: '创业邦' }
  ],
  contactInfo: {
    phone: '400-888-0000',
    email: 'contact@jmtt.com',
    address: '北京市朝阳区建国路88号JMTT大厦',
    workingHours: '周一至周日 9:00 - 21:00'
  }
};

export const articleContent = {
  id: 1,
  title: 'JMTT平台2026年第三季度发展规划与战略布局',
  author: 'JMTT官方',
  date: '2026-08-10',
  readTime: '5分钟',
  category: '平台公告',
  content: `
    <h2>前言</h2>
    <p>随着数字化转型浪潮不断深入，JMTT在2026年第三季度将继续加大技术研发投入，推出多项重磅功能，为用户提供更加完善的平台体验。本文将详细解读JMTT最新战略规划与功能路线图。</p>
    
    <h2>一、技术基础设施全面升级</h2>
    <p>2026年第三季度，JMTT将对底层技术架构进行全面升级。我们计划引入新一代分布式计算框架，将平台的数据处理能力提升300%以上。同时，我们将部署全新的容器化部署方案，实现服务的弹性伸缩，确保在高峰期依然保持流畅的用户体验。</p>
    <p>具体来说，我们将完成以下技术升级：核心数据库迁移至新一代存储引擎，查询响应速度预计提升5倍；全球CDN节点扩展至50个以上，确保全球用户都能获得低延迟访问体验；部署智能负载均衡系统，实现流量的精细化调度与管理。</p>
    
    <h2>二、智能分析模块重大更新</h2>
    <p>智能分析是JMTT最受用户欢迎的功能之一。在第三季度，我们将推出全新的智能分析2.0版本，主要更新包括：</p>
    <p>可视化数据看板：用户可以通过拖拽方式自定义数据看板布局，自由组合各类图表组件，实时监控关键业务指标。自定义报表生成器：支持多维度交叉分析和自定义计算字段，满足不同行业的个性化分析需求。AI预测分析引擎：基于深度学习算法，自动识别业务趋势和异常波动，提前预警潜在风险。</p>
    
    <h2>三、协作办公套件功能拓展</h2>
    <p>响应广大用户的需求，JMTT协作办公套件将在第三季度迎来重要功能拓展。新增在线白板功能，支持多人实时协作绘图与头脑风暴；增强文档协作能力，支持更多文件格式的在线预览与编辑；优化项目管理模块，新增甘特图视图和工作量统计功能。</p>
    
    <h2>四、安全合规体系持续完善</h2>
    <p>安全始终是JMTT的第一优先级。第三季度我们将完成ISO 27001信息安全管理体系认证续期审核，同时启动SOC 2 Type II审计准备工作。在功能层面，我们将推出细粒度权限管理系统，支持基于角色的访问控制和自定义权限模板。</p>
    
    <h2>五、用户体验全面优化</h2>
    <p>基于大量用户反馈，我们将在第三季度对平台整体交互体验进行系统性优化。包括重新设计导航结构，减少操作路径；优化页面加载性能，目标将首屏加载时间缩短至1秒以内；推出深色模式，保护用户视力；增强无障碍访问支持，让更多用户能够便捷使用JMTT。</p>
    
    <h2>结语</h2>
    <p>JMTT始终坚持以用户为中心，持续创新，追求卓越。2026年第三季度的规划只是一个新的起点，我们有信心通过不懈努力，为用户带来更加出色的产品体验。感谢每一位JMTT用户的支持与信任，让我们携手共创更加美好的数字化未来。</p>
  `
};

export const articleContents = {
  1: {
    title: 'JMTT平台2026年第三季度发展规划与战略布局',
    author: 'JMTT官方',
    date: '2026-08-10',
    readTime: '5分钟',
    category: '平台公告',
    tags: ['发展规划', '平台战略', '技术升级'],
    content: `
      <h2>前言</h2>
      <p>随着数字化转型浪潮不断深入，JMTT在2026年第三季度将继续加大技术研发投入，推出多项重磅功能，为用户提供更加完善的平台体验。本文将详细解读JMTT最新战略规划与功能路线图。</p>
      
      <h2>一、技术基础设施全面升级</h2>
      <p>2026年第三季度，JMTT将对底层技术架构进行全面升级。我们计划引入新一代分布式计算框架，将平台的数据处理能力提升300%以上。同时，我们将部署全新的容器化部署方案，实现服务的弹性伸缩，确保在高峰期依然保持流畅的用户体验。</p>
      <p>具体来说，我们将完成以下技术升级：核心数据库迁移至新一代存储引擎，查询响应速度预计提升5倍；全球CDN节点扩展至50个以上，确保全球用户都能获得低延迟访问体验；部署智能负载均衡系统，实现流量的精细化调度与管理。</p>
      
      <h2>二、智能分析模块重大更新</h2>
      <p>智能分析是JMTT最受用户欢迎的功能之一。在第三季度，我们将推出全新的智能分析2.0版本，主要更新包括：</p>
      <p>可视化数据看板：用户可以通过拖拽方式自定义数据看板布局，自由组合各类图表组件，实时监控关键业务指标。自定义报表生成器：支持多维度交叉分析和自定义计算字段，满足不同行业的个性化分析需求。AI预测分析引擎：基于深度学习算法，自动识别业务趋势和异常波动，提前预警潜在风险。</p>
      
      <h2>三、协作办公套件功能拓展</h2>
      <p>响应广大用户的需求，JMTT协作办公套件将在第三季度迎来重要功能拓展。新增在线白板功能，支持多人实时协作绘图与头脑风暴；增强文档协作能力，支持更多文件格式的在线预览与编辑；优化项目管理模块，新增甘特图视图和工作量统计功能。</p>
      
      <h2>四、安全合规体系持续完善</h2>
      <p>安全始终是JMTT的第一优先级。第三季度我们将完成ISO 27001信息安全管理体系认证续期审核，同时启动SOC 2 Type II审计准备工作。在功能层面，我们将推出细粒度权限管理系统，支持基于角色的访问控制和自定义权限模板。</p>
      
      <h2>五、用户体验全面优化</h2>
      <p>基于大量用户反馈，我们将在第三季度对平台整体交互体验进行系统性优化。包括重新设计导航结构，减少操作路径；优化页面加载性能，目标将首屏加载时间缩短至1秒以内；推出深色模式，保护用户视力；增强无障碍访问支持，让更多用户能够便捷使用JMTT。</p>
      
      <h2>结语</h2>
      <p>JMTT始终坚持以用户为中心，持续创新，追求卓越。2026年第三季度的规划只是一个新的起点，我们有信心通过不懈努力，为用户带来更加出色的产品体验。感谢每一位JMTT用户的支持与信任，让我们携手共创更加美好的数字化未来。</p>
    `
  },
  2: {
    title: 'JMTT新用户入门指南：从注册到精通只需三步',
    author: 'JMTT教程团队',
    date: '2026-08-08',
    readTime: '8分钟',
    category: '使用教程',
    tags: ['新手教程', '注册指南', '入门'],
    content: `
      <h2>前言</h2>
      <p>欢迎加入JMTT！无论您是个人用户还是企业团队，这篇入门指南将帮助您在最短时间内熟悉JMTT平台的核心功能。只需三步，从注册到精通，让我们开始吧！</p>
      
      <h2>第一步：注册与账号设置</h2>
      <p>访问JMTT官网首页，点击右上角的"立即注册"按钮。您可以选择使用手机号或邮箱进行注册。输入基本信息后，系统会向您发送验证码，完成验证即可成功注册。</p>
      <p>注册成功后，建议您立即完善个人资料：上传头像、设置昵称、绑定备用联系方式。这些信息将帮助JMTT为您提供更加个性化的服务体验。同时，建议您开启两步验证功能，进一步提升账户安全性。</p>
      
      <h2>第二步：熟悉核心功能模块</h2>
      <p>登录JMTT后，您将看到清晰的功能导航。我们建议您按照以下顺序了解核心模块：首先是数据管理模块，这是JMTT的基础，您可以在这里上传、整理和管理您的业务数据。其次是智能分析模块，系统会自动对您的数据进行分析并生成可视化报告。接下来探索协作办公模块，您可以创建项目、邀请团队成员、开始实时协作。</p>
      <p>每个模块都有详细的引导教程，您可以在使用过程中随时点击帮助图标查看。</p>
      
      <h2>第三步：进阶配置与个性化定制</h2>
      <p>当您熟悉了基础功能后，可以进行一些进阶配置来提升使用效率。在设置中心，您可以配置自动化工作流，将重复性操作自动化处理；定制数据看板，将最关注的指标放在首页；设置消息通知偏好，不错过重要信息同时避免被打扰。</p>
      
      <h2>常见问题与注意事项</h2>
      <p>在使用过程中如遇到任何问题，您可以查阅帮助中心的详细文档，或联系在线客服获取即时支持。JMTT提供7×24小时客户服务，随时为您解答疑问。</p>
    `
  }
};